module.exports = __webpack_public_path__ + "img/optimism_logo.34eec03b.svg";